import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';


export const useFirestore = () => {
  const createDocument = (collectionName, data) => {
    return addDoc(collection(db, collectionName), data);
  };

  const getDocuments = (collectionName) => {
    return getDocs(collection(db, collectionName));
  };

  return {
    createDocument,
    getDocuments,
  };
};
